import { forwardRef } from "react";
import type { HTMLAttributes } from "react";
import { cn } from "../../lib/utils";
import { itemMediaVariants, type ItemMediaProps, type ItemTitleProps, type ItemDescriptionProps } from "./styles";

const ItemMedia = forwardRef<HTMLDivElement, ItemMediaProps>(({ className, variant, ...props }, ref) => {
  return <div ref={ref} className={cn(itemMediaVariants({ variant, className }))} {...props} />;
});
ItemMedia.displayName = "ItemMedia";

const ItemContent = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => {
  return (
    <div ref={ref} className={cn("flex flex-1 flex-col gap-1 justify-center self-stretch", className)} {...props} />
  );
});
ItemContent.displayName = "ItemContent";

const ItemTitle = forwardRef<HTMLHeadingElement, ItemTitleProps>(
  ({ className, variant = "default", ...props }, ref) => {
    return (
      <h3
        ref={ref}
        className={cn(
          "text-sm font-medium leading-none",
          variant === "destructive" ? "text-destructive" : "text-foreground",
          className
        )}
        {...props}
      />
    );
  }
);
ItemTitle.displayName = "ItemTitle";

const ItemDescription = forwardRef<HTMLParagraphElement, ItemDescriptionProps>(
  ({ className, variant = "default", ...props }, ref) => {
    return (
      <p
        ref={ref}
        className={cn(
          "text-sm font-light leading-normal",
          variant === "destructive" ? "text-destructive" : "text-muted-foreground",
          className
        )}
        {...props}
      />
    );
  }
);
ItemDescription.displayName = "ItemDescription";

export { ItemMedia, ItemContent, ItemTitle, ItemDescription };
